export const fetchData = async (client: any, endpoint: any, filter: any) => {
    try {
        const payload = {
            ...filter
        };
        return await client.post(endpoint, payload);
    } catch (error) {
        console.error(`Error fetching data from ${endpoint}:`, error);
        throw error;
    }
};